import React from 'react';
import { Alert, Button, Space } from 'antd';

const RuntimeErrorState = ({
  title = 'Falha ao carregar dados do runtime',
  description = 'Tente novamente em instantes.',
  onRetry,
  retryLabel = 'Tentar novamente',
}) => {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size={12}>
      <Alert type="error" showIcon message={title} description={description} />
      {typeof onRetry === 'function' ? (
        <Button onClick={onRetry}>{retryLabel}</Button>
      ) : null}
    </Space>
  );
};

export default RuntimeErrorState;